module.exports = __webpack_public_path__ + "img/search_term.6c0aa8a.svg";